var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const _ = (value, percision = 2) => value.toFixed(percision);
// eslint-disable-next-line react/display-name
export const SVG = React.forwardRef((props, ref) => {
    const { children } = props, otherProps = __rest(props, ["children"]);
    return (React.createElement("svg", Object.assign({ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ref: ref }, otherProps), children));
});
/**
 *  Draws rectangle with hole
 */
export function createRectWithHolePath(rect, hole) {
    return `
        M ${_(rect.x)} ${_(rect.y)}
        h ${_(rect.width)}
        v ${_(rect.height)}
        h -${_(rect.width)}
        Z
        M ${_(hole.x)} ${_(hole.y)}
        v ${_(hole.height)}
        h ${_(hole.width)}
        v -${_(hole.height)}
        Z
    `;
}
export function createRoundedRectData(width, height, tlr, trr, brr, blr) {
    const radii = [tlr, trr, brr, blr, width, height].map(_);
    return [
        `M 0 ${radii[0]}`,
        ` A ${radii[0]} ${radii[0]} 0 0 1 ${radii[0]} 0`,
        ` L ${_(width - trr)} 0`,
        ` A ${radii[1]} ${radii[1]} 0 0 1 ${radii[4]} ${radii[1]}`,
        ` L ${radii[4]} ${_(height - brr)}`,
        ` A ${radii[2]} ${radii[2]} 0 0 1 ${_(width - brr)} ${radii[5]}`,
        ` L ${radii[3]} ${radii[5]}`,
        ` A ${radii[3]} ${radii[3]} 0 0 1 0 ${_(height - blr)}`,
        ' Z',
    ].join(' ');
}
export function createPercentRoundedRectData(width, height, rounded) {
    const clamped = Math.max(0, Math.min(rounded, 1));
    const radius = Math.max(clamped, Math.min(width, height) * 0.05);
    return createRoundedRectData(width, height, radius, radius, radius, radius);
}
export function LinearGradient(props) {
    const { gradient } = props;
    if (!gradient || !gradient.id) {
        return null;
    }
    return (React.createElement("linearGradient", { gradientUnits: "userSpaceOnUse", x1: gradient.p0.x, y1: gradient.p0.y, x2: gradient.p1.x, y2: gradient.p1.y, id: gradient.id }, gradient.stops.map(stop => (React.createElement("stop", { key: stop.color, offset: `${(stop.offset * 100).toFixed(2)}%`, stopColor: stop.color })))));
}
